/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/* --tim: function to Quick-Buy via aJax */
( function(){
  var doc = document.documentElement;
  var quickBuy = function( e ) {
    var el = e.target;

    if( ! el.classList.contains( 'quick-buy' ) )
      return;

    /* quick-buy clicked */
    event.preventDefault();
    if( el.attributes.disabled )
      return false;

    el.setAttribute('disabled', 'disabled');
    document.dispatchEvent(new CustomEvent('theme:loading:start'));

    var url = el.href;
    var id = el.dataset.id;
    var label = el.innerText;

    el.innerText = window.languages.adding || "Adding...";


    /*  fetch(window.routes.cartAddUrl + '.js', {
    body: "items: [{ id: ' + id +',quantity: 1}]",
    */
    fetch( url.replace( '/?', '.js?' ), {  

      credentials: 'same-origin',
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
      }
    }).then(function (response) {
      document.dispatchEvent(new CustomEvent('theme:loading:end'));
      if (response.ok) {
        el.removeAttribute('disabled');
        el.innerText = label;
        // We simply trigger an event so the mini-cart can re-render
        doc.dispatchEvent(new CustomEvent( 'cart:refresh' ));
      } else {
        response.json().then(function (content) {
          var errorMessageElement = document.createElement('span');
          errorMessageElement.className = 'ProductForm__Error Alert Alert--error';
          errorMessageElement.innerHTML = content['description'];
          addToCartButton.removeAttribute('disabled');
          addToCartButton.insertAdjacentElement('afterend', errorMessageElement);
          setTimeout(function () {
            errorMessageElement.remove();
          }, 2500);
        });
      }
    });
    return false;
  };

  doc.addEventListener( 'click', quickBuy );


})();